import {Injectable} from '@angular/core';
import {LoadingController} from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  isLoading = false;

  constructor(public loadingController: LoadingController) {
  }

  async show() {
    try {
      this.isLoading = true;
      return await this.loadingController.create({
        cssClass: 'loader-container',
        message: '',
        translucent: true,
        spinner: 'circular'
      }).then(a => {
        a.present().then(async () => {
          if (!this.isLoading) {
            await a.dismiss();
          }
        });
      });
    } catch (e) {
      // console.error(e);
    }
  }

  async hide() {
    try {
      if (this.isLoading) {
        this.isLoading = false;
        return await this.loadingController.dismiss().then(() => {
          // eslint-disable-next-line no-console
          console.info('loading dismissed');
        });
      }
    } catch (e) {
    }
  }
}
